import React from "react";
import { Table, Spinner } from "reactstrap";

export default function WestAfricaData({
  yearList = [],
  form = {},
  handleChange = (f) => f,
  rawData = [],
  setForm = (f) => f,
  stageOne,
  newArr,
  setStage,
  stage,
  countryCon,
  grouping,
  loading,
}) {
  return (
    <div>
      {loading && (
        <div>
          <Spinner /> Loading...
        </div>
      )}
      <div style={{ height: "70vh", overflow: "auto" }} className="card">
        <Table bordered striped>
          <thead>
            <tr>
              <th>
                {stageOne ? "Indicator" : countryCon ? "Year" : "Country"}
              </th>
              {countryCon && <th className="text-center">Country</th>}
              <th className="text-center">
                {countryCon ? "Indicator" : "Total"}
              </th>
              <th className="text-center">
                {countryCon ? "Total" : "Simple Average"}
              </th>
              {countryCon ||
                (!stageOne && (
                  <th className="text-center">Regional Simple Avg.</th>
                ))}
            </tr>
          </thead>
          <tbody>
            {newArr &&
              newArr.map((d, i) => (
                <tr key={i}>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (stageOne) {
                        setForm((p) => ({
                          ...p,
                          indicator: [d.indicator],
                        }));
                      } else {
                        setForm((p) => ({
                          ...p,
                          country: [d.country],
                        }));
                      }
                      setStage(stage + 1);
                      console.log(d.indicator, "Clicked country");
                    }}
                  >
                    {stageOne ? d.indicator : countryCon ? d.year : d.country}
                  </td>
                  {countryCon && <td className="text-end">{d.country}</td>}
                  <td className={countryCon ? "" : "text-end"}>
                    {countryCon
                      ? d.indicator
                      : (Math.round(d.amt * 100) / 100).toFixed(2)}
                  </td>
                  <td className={countryCon ? "" : "text-end"}>
                    {((countryCon ? d.amt : d.average * 100) / 100).toFixed(5)}
                  </td>
                  {countryCon ||
                    (!stageOne && (
                      <td className="text-end">
                        {((d.regional_average * 100) / 100).toFixed(5)}
                      </td>
                    ))}
                </tr>
              ))}
            {/* <tr>
                    <td style={{ fontWeight: "bold" }}>Total</td>
                    <td className="text-end">
                      {(Math.round(totalP * 100) / 100).toFixed(2)}
                    </td>
                    <td className="text-end">
                      {(Math.round(totalAvg * 100) / 100).toFixed(2)}
                    </td>
                  </tr> */}
          </tbody>
        </Table>
        {/* <div>
          {stageOne && (
            <div
              className="card card-body"
              style={{ height: "70vh", overflow: "auto" }}
            >
              <h3 className="text-center">
                {form.indicator} ({form.year_from} - {form.year_to})
              </h3>
              <Table bordered>
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Country</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {rawData.map((d, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{d.country}</td>
                      <td>{d.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        
        </div> */}
      </div>
    </div>
  );
}
